import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {WorkingTimeJsonProperties} from "../../models/working-time-json-properties";
import {Observable} from "rxjs";
import Helpers from "../../utils/helpers";

@Injectable()
export class TimeManagementService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {}

  public getWorkingTimeProperties(): Observable<WorkingTimeJsonProperties> {
    return this.http.get(this.baseUrl + "timemanagement") as Observable<WorkingTimeJsonProperties>;
  }

  public saveWorkingTimeProperties(workingTimeJsonProperties: WorkingTimeJsonProperties) {
    Helpers.trimRecursiveObj(workingTimeJsonProperties);
    const body = JSON.stringify(workingTimeJsonProperties);
    return this.http.put(this.baseUrl + "timemanagement", body, {responseType: "text"});
  }
}
